//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';
import { forwardRef } from "react";

import {
  KeyboardArrowDown,
  KeyboardArrowRight,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from './Styled/Styled';
import Props from 'components/_properties/index';
import { PanelDirection } from 'pages/FileViewer/components/Panel/PanelData';

//#endregion


const GroupHorizontal  = (props) => {
  const { chilren, styles, ...rest } = props;
  return (
    <Styled styles={[Props.group_horizontal, Props.fill, Props.wrap, Props.no_overflow, ...props?.styles||[] ]} children={props.children} {...rest}/>
  )
}

const Spacer = (props) => {
  const { size = 1, unit='rem' } = props;
  return (
    <Styled styles={[ Props.size.set(size,size,unit) ]} />
  )
}

//-----------------------------------------------------------------
function Collapsible(props, ref) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  let {
    styles,
    header={},
    header_closed,
    body={},
    body_closed={},
    direction=PanelDirection.ROW,
    handleOpen,
    handleClose,
  } = props;
  header        = { children:null,styles:[{}], ...header        };
  header_closed = { children:null,styles:[{}], ...header_closed };
  body          = { children:null,styles:[{}], ...body          };
  body_closed   = { children:null,styles:[{}], ...body_closed   };

  const [is_open, setIsOpen] = useState( props.is_open ?? true );

  const is_col = direction === PanelDirection.COL;
  const closed = is_open ? {} : {};
  if( !is_open && !is_col ) closed.height = 'fit-content';
  if( !is_open &&  is_col ) closed.width  = '25px';

  const closed_body   = is_open ? {} : { height: 0 , visibility:'hidden'  };
  const icon          = is_open ? <KeyboardArrowDown /> : <KeyboardArrowRight />;

  const size_25px = Props.size.set(25,25,'px');

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Header() {
    //-----------------------------------------------------------------
    if( is_open ) {
      if(handleClose) handleClose();
    } else {
      if(handleOpen) handleOpen();
    }

    setIsOpen(!is_open)
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[...styles, closed]} ref={ref}>
        {displayHeader()}
        {displayBody()}
      </Styled>
    )
  }

  //-----------------------------------------------------------------
  function displayHeader() {
    //-----------------------------------------------------------------
    return (
      <GroupHorizontal styles={[{height: 'fit-content'},...(is_open?header.styles:header_closed.styles ?? header.styles)]} onClick={onClick_Header} >
        <Styled styles={[{display: 'flex'},{alignContent: 'center', alignItems: 'center'}]}>
          <Spacer />
          <Styled styles={[size_25px,Props.center_v,{ cursor: 'pointer'}]} >
            {icon}
          </Styled>
          {is_open ? header.children : header_closed.children}
          <Spacer />
        </Styled>
      </GroupHorizontal>
    )
  }

  //-----------------------------------------------------------------
  function displayBody() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[...body.styles,{ height: 'calc( 100% - 25px )'}, closed_body, ...(is_open?[]:body_closed.styles||[])]} >
        {body.children}
      </Styled>
    )
  }

  //#endregion

  return display();
}

export default forwardRef( Collapsible );

export const Header = (props) => {
  const {
    height = 25,
    width  = 2,
    title  = '',
    styles = [],
    fill_height = false,
    fill_width  = true,
  } = props;

  const font_size = (height / 2)+'px';
  return (
    <Styled styles={[{display: 'flex'}, {minHeight: height+'px', height: 'fit-content'}, { alignItems: 'center' }, ...styles ]}>
      <div style={{fontSize: font_size}}>{title}</div>
      {/* <Spacer /> */}
    </Styled>
  )
}